<template>
  <div>
    <v-container 
      class="overflow-y-auto" 
      id="scroll-target" 
      style="max-height: 700px; height:700px" 
      accent>
      <v-app-bar color="accent" dark rounded flat>
        <v-toolbar-title>{{ today }}のジョブ</v-toolbar-title>
      </v-app-bar>
      <div v-if="todaysJobs.length!=0">
        <v-row dense>
          <v-card v-for="(todaysJob, i) in todaysJobs" :key="i" class="mb-3">
              <router-link :to="dispJobDetailLink(todaysJob)" style="text-decoration: none;">
                <v-img
                  :src="todaysJob.imagePath"
                  class="white--text align-end text-left"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="200px"
                  row
                >
                <v-col cols="12" style="height: 130px;">
                  <v-chip v-if="!isDone(todaysJob)" color="red" text-color="white">未完了</v-chip>
                  <v-chip v-else  color="green" text-color="white">完了</v-chip>
                  <strong class="mx-6">{{ dispJobTarget(todaysJob) }}</strong>
                </v-col>
                  <v-card-title  v-text="todaysJob.jobName"></v-card-title>
                </v-img>
              </router-link>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-list-item class="grow">
                <v-list-item-content class="text-left">
                  <v-list-item-title v-if="!todaysJob.groupId" class="text-left">個人ジョブ</v-list-item-title>
                  <v-list-item-title v-if="todaysJob.groupId" class="text-left">グループジョブ</v-list-item-title>
                </v-list-item-content>
                <v-btn v-if="!isDone(todaysJob)" @click.stop="recordJob(todaysJob)" color="accent">
                  記録する
                </v-btn>
              </v-list-item>
            </v-card-actions>
          </v-card>
        </v-row>
        <v-dialog v-model="recordJobModal" width="600" persistent>
          <record-job-modal-component @close="closeModal" :job="job"></record-job-modal-component>
        </v-dialog>
      </div>
      <div v-else>
        <v-card outlined>
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              <h4 class="text-center">{{ today }}のジョブはありません</h4>
              <p class="text-center">ジョブを作成しましょう！</p>
            </v-card-text>
          </div>
        </v-card>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import RecordJobModalComponent from '../components/RecordJobModal.vue';
import moment from "moment";
moment.locale("ja")
  export default {
    components: {
      RecordJobModalComponent
    },
    data (){
      return {
        job:{},
        recordJobModal: false,
        today: moment().format('YYYY年MM月DD日(ddd)')
      }
    },
    computed: {
      todaysJobs(){
        const today = moment();
        const todaysJobs = [];
        const myJobs = this['job/myJobs'].filter(myJob => myJob.jobStatus == 1)
        myJobs.forEach(myjob => {
          if(!myjob.groupId){
            if(myjob.scheduledDate[today.format('YYYY-MM-DD')] != null) todaysJobs.push(myjob)
          } else{
            if(today.isBetween(moment(myjob.startDate), moment(myjob.finishDate))) todaysJobs.push(myjob)
          }
        })
        return todaysJobs;
      },
      ...mapGetters(['loginUserId', 'job/myJobs', 'record/myRecords'])
    },
    methods: {
      isDone(todaysJob){
        const today = moment().format('YYYY-MM-DD')
        // 今日日付の個人ジョブが実施済みかをチェックする
        if(!todaysJob.groupId) {
          return todaysJob.scheduledDate[today]
        // 今日日付のグループジョブのレコードがあるかをチェックする
        } else{
          const jobId = todaysJob.jobId;
          const userId = this.loginUserId
          return this['record/myRecords'].some(record => {
            return record.jobId === jobId 
                    && record.userId === userId 
                    && moment.unix(record.recordAt.seconds).format('YYYY-MM-DD') === today
          })
        }
      },
      dispJobDetailLink(todaysJob){
        const jobId = todaysJob.jobId
        return !todaysJob.groupId ? {name: 'JobDetail', params: { 'job_id': jobId }} 
                                  : {name: 'GroupJobDetail', params: { 'job_id': jobId }}
      },
      dispJobTarget(todaysJob){
        const jobContinueCount = todaysJob.memberList.reduce((prev, current) => prev + current.jobContinueCount, 0)
        const remainingNumber = !todaysJob.groupId ? todaysJob.jobTargetContinueCount - jobContinueCount
                                                   : todaysJob.jobTargetTotalCount - jobContinueCount;
        const message = remainingNumber == 0 ? '目標達成！' : `目標達成まであと${remainingNumber}回！`;
        return message;
      },
      recordJob(todaysJob){
        this.toggleRecordJobModal();
        this.job = todaysJob;
      },
      toggleRecordJobModal(){
        this.recordJobModal = !this.recordJobModal
      },
      closeModal(){
        this.recordJobModal = false;
      }
    },
  }
</script>
